const openModalButton = document.querySelector('.openModalButton');
const modal = document.getElementById('FindALabModal');
const modalBackground = document.querySelector('#FindALabModal .modal-background');
const closeButton = document.querySelector('#FindALabModal .modal-close');

/**
 * Handles the open modal button caction
 */
function handleClickOpenModalButton() {
  window.dispatchEvent(new Event('openmodal'));
  modal.classList.add('is-active');
}

/**
 * Handles the close modal action
 */
function handleClickCloseModal() {
  modal.classList.remove('is-active');
  window.dispatchEvent(new Event('closemodal'));
}

// Open the modal when the button is clicked
if (openModalButton) {
  openModalButton.addEventListener('click', handleClickOpenModalButton);
}

// Close the modal when the close button or background is clicked
if (modalBackground && closeButton) {
  modalBackground.addEventListener('click', handleClickCloseModal);
  closeButton.addEventListener('click', handleClickCloseModal);
}
